import Admin from './Admin'
import Account from './Account'
import Users from './Users'
import RulesWhitelist from './RulesWhitelist'
import Preferences from './Preferences'
import Allowlist from './Allowlist'
import AllowlistWorkflow from './AllowlistWorkflow'
import JiraSetting from './JiraSetting'

export { Admin, Account, Users, RulesWhitelist, Preferences, Allowlist, AllowlistWorkflow, JiraSetting }



// WEBPACK FOOTER //
// ./src/views/admin/index.js